export enum PanelClientsEditQuickActionsEventsEnum {
    ChangeStatus,
    AddDocument,
    AddTradingAccount,
    TradingAccountsBlocked,
    MakeTransfer,
    AddBank,
    AddUser,
    AssignAccessRights
}
